module.exports = __webpack_public_path__ + "img/zywl.6748e01e.jpg";